import { propEq, Tuple } from "ramda";
import { useMemo } from "react";
import { useLanguage } from "./useLanguage";

export function useDayPeriods(): Tuple<string, 2> {
  const language = useLanguage();

  return useMemo(() => {
    const formatter = new Intl.DateTimeFormat(language, {
      hour: "numeric",
      hour12: true,
    });

    return [
      // am
      formatter.formatToParts(new Date("2023-01-01T10:00:00")),
      // pm
      formatter.formatToParts(new Date("2023-01-01T20:00:00")),
    ].map((parts) => parts.find(propEq("dayPeriod", "type"))!.value) as Tuple<
      string,
      2
    >;
  }, [language]);
}
